import axios from 'axios'
import { provideJWT } from './token'
import { getQzConfig } from '../../config'

const createClient = () => {
	const client = axios.create({
		baseURL: getQzConfig().signBaseUrl
	})

	client.interceptors.request.use(provideJWT)

	return client
}

export { createClient }



// WEBPACK FOOTER //
// ./src/common/api/signClient.js